import { Component } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrl: './progress-spinner.component.scss',
  standalone: true,
  imports: [MatProgressSpinner]
})
export class ProgressSpinnerComponent {

  constructor(public loader: LoaderService) { }
}
